import { useFoundCollaborator, useSession } from '@ferreri/minato-auth-react';

import { SETTINGS } from '../config/settings';

export const useRedirectToContractDraft = (planVersionId?: string | number) => {
  const { data: session, isLoading } = useSession();
  const { data: collaborator } = useFoundCollaborator();

  const redirectToContractDraft = () => {
    if (
      isLoading ||
      planVersionId === undefined ||
      planVersionId === null ||
      planVersionId === ''
    ) {
      return;
    }

    const currentParams = new URLSearchParams(window.location.search);
    const contractBase = (SETTINGS.public.urlContractWeb || '').replace(
      /\/+$/,
      '',
    );
    const saleBase = (SETTINGS.public.urlSaleWeb || '').replace(/\/+$/, '');

    const accountId = currentParams.get('account_id');
    const sellerId =
      currentParams.get('seller_id') || collaborator?.external_id || '';

    if (collaborator?.found) {
      if (accountId) {
        const targetUrl = new URL(
          `${contractBase}/accounts/${encodeURIComponent(
            accountId,
          )}/plan-versions/${encodeURIComponent(
            String(planVersionId),
          )}/contract-drafts/new`,
          window.location.origin,
        );

        currentParams.forEach((value, key) => {
          if (key !== 'account_id' && key !== 'seller_id') {
            targetUrl.searchParams.append(key, value);
          }
        });
        if (sellerId) {
          targetUrl.searchParams.set('seller_id', sellerId);
        }

        window.location.assign(targetUrl.toString());
        return;
      }

      const targetUrl = new URL(
        `${saleBase}/portal/sales/account/search/holder`,
        window.location.origin,
      );

      currentParams.forEach((value, key) => {
        if (key !== 'plan_version_id') {
          targetUrl.searchParams.append(key, value);
        }
      });
      targetUrl.searchParams.set('plan_version_id', String(planVersionId));

      window.location.assign(targetUrl.toString());
      return;
    }

    const targetUrl = new URL(
      `${contractBase}/plan-versions/${encodeURIComponent(
        String(planVersionId),
      )}/contract-drafts/new`,
      window.location.origin,
    );

    currentParams.forEach((value, key) => {
      targetUrl.searchParams.append(key, value);
    });

    if (session?.id) {
      window.location.assign(targetUrl.toString());
      return;
    }

    const authBase = (SETTINGS.public.urlAuthWeb || '/auth').replace(
      /\/+$/,
      '',
    );
    const loginUrl = new URL(authBase, window.location.origin);
    loginUrl.searchParams.set('redirect_to', targetUrl.toString());
    loginUrl.searchParams.set('return_to', targetUrl.toString());

    window.location.assign(loginUrl.toString());
  };

  return { redirectToContractDraft, isLoading };
};
